<script lang="ts" setup>
  withDefaults(
    defineProps<{
      disabled?: boolean;
      type?: 'button' | 'submit';
      appearance?: 'outline' | 'primary' | 'spotify';
    }>(),
    {
      type: 'button',
      appearance: 'primary',
    },
  );
</script>

<template>
  <button :data-appearance="appearance" :disabled="disabled" :type="type">
    <slot name="icon" />
    <slot />
  </button>
</template>

<style scoped>
  button {
    --button-icon-size: 2rem;
    --button-padding-block: 1.125rem;

    align-items: center;
    background-color: var(--color-primary);
    border: none;
    border-radius: var(--radius-control);
    color: var(--color-on-primary);
    cursor: pointer;
    display: flex;
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-strong);
    gap: 0.5rem;
    justify-content: center;
    line-height: 1.2;
    max-width: var(--control-max-width);
    min-height: max(var(--size-touch-target), calc(var(--button-icon-size) + 2 * var(--button-padding-block)));
    padding: var(--button-padding-block) 1.5rem;
    text-align: center;
    transition: transform 0.1s;
    width: 100%;

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    &:disabled {
      background-color: var(--color-disabled);
      cursor: not-allowed;
    }

    &:active:not(:disabled) {
      transform: scale(0.95);
    }
  }

  :slotted(img) {
    height: var(--button-icon-size);
    width: var(--button-icon-size);
  }

  [data-appearance='spotify'] {
    background-color: var(--color-spotify);
    color: var(--color-on-spotify);
  }

  [data-appearance='outline'] {
    background-color: transparent;
    border: 2px solid var(--color-primary);
    color: var(--color-primary);
    font-size: var(--font-size-md);
  }
</style>
